// Gallery JS

var Flickity = require('flickity');

const galleryElems = document.querySelectorAll('.gallery-carousel');
const arrowShape = 'm.5 50.031 50.986 21.815 1.931-4.512-34.771-14.878H100v-4.909H18.736L53.42 32.666l-1.937-4.512z';

galleryElems.forEach((elem) => {
  let flkty = new Flickity(elem, {
    cellSelector: '.gallery-carousel-cell',
    cellAlign: 'left',
    wrapAround: true,
    pageDots: false,
    arrowShape: arrowShape,
    lazyLoad: 1,
    setGallerySize: false,
  });
})

const galleryTabs = document.querySelectorAll('.gallery-tabs .nav-link');

galleryTabs.forEach((tabElem) => {
  tabElem.addEventListener('shown.bs.tab', event => {
    let tabPanelId = event.target.dataset.bsTarget;
    let carousel = document.querySelector(tabPanelId + ' .gallery-carousel');

    if (carousel) {
      let flkty = Flickity.data(carousel);
      flkty.resize();
    }
  })
});
